import React from "react";
import RouteResultCard from "./RouteResultCard";
import ReceiptResultCard from "./ReceiptResultCard";
import ProductResultCard from "./ProductResultCard";

export default function ResultCard({
  item,
  entityType,
  isExpanded,
  toggleExpand,
  onCopy,
}) {
  const safeId =
    item.id || item.receipt_id || item.product_id || `${entityType}-${Math.random()}`;

  const title =
    entityType === "route"
      ? `Маршрут ${item.route_number || item.id}`
      : entityType === "receipt"
      ? `Квитанция ${item.receipt_number || item.id}`
      : `Товар ${item.product_name || item.product_number || item.id}`;

  const link =
    entityType === "route"
      ? `/admin/routedebug/${item.id}`
      : entityType === "receipt"
      ? `/admin/receiptdebug/${item.id}`
      : `/admin/productdetail/${item.id}`;

  return (
    <div
      key={safeId}
      style={{
        borderRadius: "0.75rem",
        border: "1px solid #e2e8f0",
        padding: "0.9rem",
        background: "#ffffff",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: "0.5rem" }}>
        <div>
          <h3
            style={{
              margin: 0,
              marginBottom: "0.3rem",
              fontSize: "0.95rem",
              fontWeight: 600,
              color: "#0f172a",
            }}
          >
            {title}
          </h3>
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#64748b" }}>
            ID: {item.id || "—"}
          </p>
        </div>
        <span
          style={{
            alignSelf: "flex-start",
            fontSize: "0.7rem",
            padding: "0.15rem 0.4rem",
            borderRadius: "999px",
            background: "#eff6ff",
            color: "#1d4ed8",
            textTransform: "uppercase",
            letterSpacing: "0.03em",
          }}
        >
          {entityType}
        </span>
      </div>

      {entityType === "route" && (
        <RouteResultCard item={item} isExpanded={isExpanded} onCopy={onCopy} />
      )}
      {entityType === "receipt" && (
        <ReceiptResultCard item={item} isExpanded={isExpanded} onCopy={onCopy} />
      )}
      {entityType === "product" && (
        <ProductResultCard item={item} isExpanded={isExpanded} onCopy={onCopy} />
      )}

      <div
        style={{
          marginTop: "0.6rem",
          display: "flex",
          justifyContent: "space-between",
          gap: "0.4rem",
          fontSize: "0.8rem",
        }}
      >
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            borderRadius: "999px",
            border: "1px solid #e2e8f0",
            padding: "0.25rem 0.7rem",
            background: "#f8fafc",
            color: "#0f172a",
          }}
        >
          Открыть детально
        </a>
        <button
          type="button"
          onClick={toggleExpand}
          style={{
            borderRadius: "999px",
            border: "1px solid #e2e8f0",
            padding: "0.25rem 0.7rem",
            background: "#f8fafc",
            cursor: "pointer",
          }}
        >
          {isExpanded ? "Скрыть детали / JSON" : "Показать детали / JSON"}
        </button>
      </div>

      {isExpanded && (
        <details
          style={{
            marginTop: "0.5rem",
            fontSize: "0.75rem",
          }}
        >
          <summary style={{ cursor: "pointer", color: "#64748b" }}>
            Сырой JSON
          </summary>
          <pre
            style={{
              marginTop: "0.3rem",
              maxHeight: "260px",
              overflow: "auto",
              background: "#f8fafc",
              padding: "0.6rem",
              borderRadius: "0.5rem",
              border: "1px dashed #e2e8f0",
            }}
          >
            {JSON.stringify(item, null, 2)}
          </pre>
        </details>
      )}
    </div>
  );
}
